import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="mt-16 mb-8">
      <div className="container mx-auto px-4">
        <div className="glass-card p-8 rounded-xl border border-white/5 shadow-lg backdrop-blur-md">
          <div className="text-center space-y-4">
            <p className="text-sm text-white/80">
              © 2023 PREPT. {t('all_rights_reserved')}
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="/privacy" className="text-white/70 hover:text-white transition-colors hover:underline">
                {t('privacy_policy')}
              </a>
              <a href="/terms" className="text-white/70 hover:text-white transition-colors hover:underline">
                {t('terms_of_service')}
              </a>
              <a href="/help" className="text-white/70 hover:text-white transition-colors hover:underline">
                {t('help')}
              </a>
              <a 
                href="https://instagram.com/preptcine" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/70 hover:text-white transition-colors hover:underline"
              >
                {t('instagram')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
